// modules
import { get, has } from 'lodash'
import { createSelector } from 'reselect'

// utils
import addAllValue from 'src/utils/functions/addAllValue'
import { makeOneLevelArray } from 'src/utils/functions/makeOneLevelArray'

const diseases = (state = {}) => get(state, ['company', 'diseases'], [])

export const companyDiseasesSelector = createSelector(
  diseases,
  (diseases) => diseases
)

export const companyDiseasesWithAll$ = createSelector(
  companyDiseasesSelector,
  (diseases = []) => addAllValue(diseases)
)

export const companyPrimaryDiseasesSelector = createSelector(
  companyDiseasesSelector,
  (diseases) => diseases
)

export const companyDiseasesClinicalPathway$ = createSelector(
  companyDiseasesSelector,
  (diseases) =>
    diseases
      .filter(
        ({ isVisibleForClinicalPathway = true }) => isVisibleForClinicalPathway
      )
      .map((item) =>
        !has(item, 'children')
          ? item
          : {
              ...item,
              children: item.children.filter(
                ({ isVisibleForClinicalPathway = true }) =>
                  isVisibleForClinicalPathway
              )
            }
      )
)

export const companyDiseasesEnrollmentProgram$ = createSelector(
  companyDiseasesSelector,
  (diseases) =>
    makeOneLevelArray(diseases).filter(
      ({ isVisibleForEnrollment = false, isDeleted }) =>
        !isDeleted && isVisibleForEnrollment
    )
)

export const companyChildrenDiseasesSelector = createSelector(
  companyDiseasesSelector,
  (diseases) => diseases.reduce((acc, el) => [...acc, ...el.children], [])
)

export const companyDiseasesDropdown$ = createSelector(
  companyDiseasesSelector,
  (diseases) =>
    diseases
      .reduce((acc, item) => [...acc, ...item.children], [])
      .map((item, key) => ({
        ...item,
        key,
        title: item.name,
        value: item.uuid
      }))
)
